import { Utils } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { PickController } from "./PickController";
import { DataManager } from "../../Managers/DataManager";
import { GameManager } from "../../Managers/GameManager";
import { MessageManager } from "../../Managers/MessageManager";

export class PickModel {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected controller: PickController;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(controller: PickController) {
        this.controller = controller;
    }

    //******************************************************************************************************************
    //  REQUESTS
    //******************************************************************************************************************

    public start(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.start(Communication.Game.GameModules.Pick).then((response: any): any => {
            MessageManager.postpone(this.startReceived.bind(this), response);
        });
    }

    public select(id: number): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.pickSelect(id).then((response: any): any => {
            MessageManager.postpone(this.selectReceived.bind(this), response);
        });
    }

    public end(): void {
        if (GameManager.requestSend) {
            return;
        }

        GameManager.requestSend = true;
        DataManager.controlAutoplay();
        GameManager.gameClient.end(Communication.Game.GameModules.Pick).then((response: any): any => {
            MessageManager.postpone(this.endReceived.bind(this), response);
        });
    }

    //******************************************************************************************************************
    //  RESPONSES
    //******************************************************************************************************************

    protected startReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            Platforms.Platforms.featureStarted({ type: Communication.Game.GameModules.Pick });
            this.controller.startReceived();
        }

        GameManager.requestSend = false;
    }

    protected selectReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            this.controller.selectReceived();
        }

        GameManager.requestSend = false;
    }

    protected endReceived(response: Communication.Game.GameResponse): void {
        if (!Utils.isNullOrUndefined(response)) {
            GameManager.parseResponses(response);
            DataManager.updateResponseData();

            Platforms.Platforms.featureFinished({ type: Communication.Game.GameModules.Pick });
            this.controller.endReceived();
        }

        GameManager.requestSend = false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/PickModel.ts
 **/